import i18n, { TFunction } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en_res from './languages/MACRO_en.json';
import * as Yup from 'yup';
import { ILanguage } from '../api/IApiResponse';

const resources = {
    en: {
        translation: en_res,
    }
};

const options = {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: 'i18nextLng',
};

const defaultLanguage = 'en';

export const getLanguage = (): string => window.localStorage.getItem(options.lookupLocalStorage)!;

export const loadLanguages = async (languages: ILanguage[]) => {
    for (let lan of languages) {
        const res = await import(`./languages/${lan.languageFileName}`);
        i18n.addResourceBundle(lan.languageCode, 'translation',
            res);
        if (lan.languageCode == getLanguage()) {
            changeLanguage(getLanguage() ?? "en");
        }
    }
}

export const changeLanguage = (language: string) => {
    i18n.changeLanguage(language); yupLocalize(null, i18n.t);
};

export default i18n;

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: defaultLanguage,
        debug: false,
        detection: options,
        interpolation: {
            escapeValue: false,
        },
    }, yupLocalize);

function yupLocalize(_: unknown, t: TFunction) {
    const yupLoc = t("yup", { returnObjects: true });
    //console.log(yupLoc);
    if (JSON.stringify(yupLoc) != '"yup"') {
        Yup.setLocale(yupLoc);
    }
}